interface ExploreCard {
    linkTo: string;
    background: string;
    title: string;
    subtitle: string;
}

export const exploreObjects: ExploreCard[] = [
    {
        linkTo: '/myboomers',
        background: '/frontpage/boomerBanner1.png',
        title: 'My Boomers',
        subtitle: 'View your Boomer gen 0 NFTs and withdraw from mattress fund'
    },
    {
        linkTo: '/myzoomers',
        background: '/frontpage/zoomers_banner1.png',
        title: 'My Zoomers',
        subtitle: 'View your collection, change variants, and more'
    },
    {
        linkTo: '/boomrooms',
        background: '/frontpage/roomBanner1.png',
        title: 'Boom Rooms',
        subtitle: 'Construct, Decorate, and Stake your rooms'
    },
    {
        linkTo: '/comics',
        background: '/frontpage/storyBanner2.png',
        title: 'Comics',
        subtitle: 'Read about the story behind Boomers and Zoomers'
    },
]
